import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/time";

export const CALL_RESULT = {
  confirmed: { l: "Confermato", c: "bg-emerald-100 text-emerald-800" },
  reschedule: { l: "Da spostare", c: "bg-amber-100 text-amber-800" },
  no_answer: { l: "Non risponde", c: "bg-red-100 text-red-700" },
  no_input: { l: "Nessuna scelta", c: "bg-red-100 text-red-700" },
  error: { l: "Errore", c: "bg-red-100 text-red-700" },
  no_phone: { l: "Telefono mancante", c: "bg-red-100 text-red-700" },
  ticket_changed: { l: "Annullata", c: "bg-secondary text-muted-foreground" },
};

export const ConfirmCallLog = ({ refreshKey }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/confirm-calls").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); const iv = setInterval(load, 10000); return () => clearInterval(iv); }, [refreshKey]);
  return (
    <div className="mt-5 border-t border-border pt-4" data-testid="cc-log">
      <div className="mb-2 flex items-center justify-between">
        <p className="text-sm font-bold text-navy">Ultime chiamate</p>
        <button type="button" onClick={load} className="text-muted-foreground hover:text-foreground"><RefreshCw size={14} /></button>
      </div>
      {rows.length === 0 ? <p className="text-xs text-muted-foreground">Nessuna chiamata ancora.</p> : (
        <div className="max-h-64 space-y-1 overflow-y-auto">
          {rows.map((c) => {
            const r = CALL_RESULT[c.result] || { l: c.status === "calling" ? "In corso…" : c.status === "queued" ? "In coda" : c.result || c.status, c: "bg-secondary text-foreground" };
            return (
              <div key={c.id} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`cc-log-${c.id}`}>
                <span className="w-24 font-mono font-bold text-primary">{c.test ? "PROVA" : c.ticket_code}</span>
                <span className="w-32 text-muted-foreground">{c.phone || "—"}</span>
                <span className="w-24 text-muted-foreground">{c.appointment_date ? fmtDate(c.appointment_date) : ""}</span>
                <span className={`rounded-full px-2 py-0.5 font-semibold ${r.c}`}>{r.l}</span>
                {c.attempts ? <span className="text-muted-foreground">{c.attempts} tent.</span> : null}
                {c.error ? <span className="truncate text-destructive" title={c.error}>{c.error}</span> : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
